module.exports = __webpack_public_path__ + "static/media/car-icon.34008bb7.png";